import { ReactNode } from 'react';

import { Heading } from '@/modules/theme/components/Typography';
import { blue } from '@/modules/theme/utils/colors';

import { AuthBackground } from '../common/AuthBackground';

import {
  CardStyled,
  CardWrapperStyled,
  FlexContainerStyled,
  HeroSectionStyled,
  LogoHorizontalWhiteStyled,
} from './AuthContentLayout.styled';
import { AuthContentLayoutMode } from './types';

type AuthContentLayoutProps = {
  children: ReactNode;
  title?: string;
  mode?: AuthContentLayoutMode;
};

export const AuthContentLayout = ({
  children,
  title,
  mode = 'default',
}: AuthContentLayoutProps) => {
  return (
    <AuthBackground>
      <HeroSectionStyled mode={mode}>
        <LogoHorizontalWhiteStyled />
        <CardWrapperStyled>
          <CardStyled>
            <FlexContainerStyled justify="center">
              <Heading variant="h3" color={blue[700]} as="h1">
                {title}
              </Heading>
            </FlexContainerStyled>
            {children}
          </CardStyled>
        </CardWrapperStyled>
      </HeroSectionStyled>
    </AuthBackground>
  );
};
